(function ($) {

	$(function () {

		if ($(".jobs").length > 0) {
			$("body").on("click", '.content-container .plus', function () {

				var content_container = $(this).parents(".content-container");

				//toggle open class to the content-container parent
				content_container.toggleClass("open");

				//if this parent has open class, add gray filter to the other profiles and remove grayed from this parent
				if (content_container.hasClass("open")) {
					content_container.removeClass("grayed");
					//remove open from all other opened boxes
					$(".content-container").not(content_container).each(function (index, element) {
						$(element).removeClass("open");
						$(element).addClass("grayed");
					});
				}
				//else remove the gray filter from the other profiles
				else {
					$(".content-container").not(".open").each(function (index, element) {
						$(element).removeClass("grayed");
					});
				}

			});
		}

	});

})(jQuery);